import './App.css'
import * as React from 'react';
import {useEffect, useState} from 'react';
import MenuBar from "./MenuBar.tsx";
import {List, ListItem, ListItemText, SwipeableDrawer} from "@mui/material";
import DrawerList from "./DrawerList.tsx";
import Products from "./Products.tsx";
import Control from "./Control.tsx"
import Divider from '@mui/material/Divider';
import ShopDialog from "./ShopDialog.tsx";
import {useNotifications} from '@toolpad/core/useNotifications';
import QRReader from "./QrReader.tsx";
import {useBasket} from "./useBasket.ts";
import IconButton from "@mui/material/IconButton";
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import useSalepoints from "./useSalepoints.ts";
import {getClientUID, joinStringsWithLimit} from "./helpers.ts";
import {loadBasketsList} from "./uc/services.ts";
interface AppProps {
    component: ""
}

function App(props: AppProps) {
    const [drawerState, setDrawerState] = useState(false)
    const [baskets, setBaskets] = useState([])
    const {favoriteShop} = useSalepoints()
    const onDrawerClose = () => {
        setDrawerState(false)
    }
    const {currentEditProduct, setCurrentEditProduct,
        products, basket, newBasket, total, deleteBasket} = useBasket()
    const [shopDialogOpen, setShopDialogOpen] = useState(false)
    const handleClose = React.useCallback(() => {
        setShopDialogOpen(false);
    }, []);
    useEffect(() => {
        if (!favoriteShop) {
            setShopDialogOpen(true)
        }
        if (props.component == "docs") {
            loadBasketsList(getClientUID(), favoriteShop!.sanremoRef).then(result => {
                setBaskets(result)
            })
        }
    }, [favoriteShop]);
    function pageRoute(component: string) {
        if (component == "docs") {
            return <>
                <List sx={{bgcolor: 'background.paper'}}>
                    {baskets.map(el => <ListItem key={el.id} secondaryAction={<IconButton edge="end" aria-label="delete" onClick={() => {
                        // changeBasket(el)
                        window.location.href = "/"
                    }}>
                        <FolderOpenIcon/>
                    </IconButton>}>
                        <ListItemText primary={
                            <span>ИД: {el.id} сумма: {el.products.reduce((accum, product) => accum + product.price * product.quantity, 0)} руб. </span>}
                                      secondary={<span>{joinStringsWithLimit(el.products.map(product => product.name),250,3)}</span>}
                        />
                    </ListItem>)}
                </List>
            </>
        }
        return <><QRReader onScanResult={setCurrentEditProduct}/>
            <Control basketID={basket?.id || ""} sum={total} isScanStart={false} toggleScan={() => {
            }} deleteBasket={() => {
                confirm("Удалить корзину и создать новый документ?") && deleteBasket()
            }} saveBasket={() => {
                newBasket(favoriteShop!.sanremoRef, products)
            }}/>
            <Divider style={{margin: '10px'}}/>
            <Products products={products}
                      currentEditProduct={currentEditProduct}
                      setCurrentEditProduct={setCurrentEditProduct}/>
        </>
    }
    return (
        <>
            <MenuBar openDrawer={setDrawerState} title={'basket'}/>
            <ShopDialog open={shopDialogOpen} handleClose={handleClose}/>
            <SwipeableDrawer open={drawerState} onOpen={() => {
                setDrawerState(true)
            }} onClose={onDrawerClose}>
                <DrawerList/>
            </SwipeableDrawer>
            {pageRoute(props.component)}
        </>
    )
}

export default App
